import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { 
    setFavoriteHotel, 
    setFavoriteAdventure, 
    setFavoriteDining,
    setFavoriteEvent,
    setFavoriteConferenceVenue,
    removeFavoriteHotel,
    removeFavoriteAdventure,
    removeFavoriteDining,
    removeFavoriteEvent,
    removeFavoriteConferenceVenue,
} from 'store';
/* import { currentLanguage } from 'helpers'; */

import FavoriteIcon from 'icons/Favorite/FavoriteIcon';
import FavoriteIconFilled from 'icons/Favorite/FavoriteIconFilled';

import Media from 'css/Media';


export class FavoriteButton extends Component {
    state = {
        
    }

    handleClick = () => {
        let sort = this.props.sort === 'accommodation' ? 'hotels' : this.props.sort;
        const { id } = this.props.item;
        const { hotels, adventures, dining, events, conference_venues} = this.props.favorites;
        //let isFavorited;

        if(sort === 'hotels') {
            if(hotels.includes(id)) {
                this.props.removeFavoriteHotel(id);
                //isFavorited = false;
            } else {
                this.props.setFavoriteHotel(id);
                //isFavorited = true;
            }
        } else if(sort === 'adventures') {
            if(adventures.includes(id)) {
                this.props.removeFavoriteAdventure(id);
                //isFavorited = false;
            } else {
                this.props.setFavoriteAdventure(id);
                //isFavorited = true;
            }
        } else if(sort === 'dining') {
            if(dining.includes(id)) {
                this.props.removeFavoriteDining(id);
                //isFavorited = false;
            } else {
                this.props.setFavoriteDining(id);
                //isFavorited = true;
            }
        } else if(sort === 'events') {
            if(events.includes(id)) {
                this.props.removeFavoriteEvent(id);
                //isFavorited = false;
            } else {
                this.props.setFavoriteEvent(id);
                //isFavorited = true;
            }
        } else if(sort === 'conference_venues') {
            if(conference_venues.includes(id)) {
                this.props.removeFavoriteConferenceVenue(id);
                //isFavorited = false;
            } else {
                this.props.setFavoriteConferenceVenue(id);
                //isFavorited = true;
            }
        }
        
    }

    render() {
        const { favorites, item } = this.props;
        let sort = this.props.sort === 'accommodation' ? 'hotels' : this.props.sort;

        return (
            <React.Fragment>
                <Wrapper 
                    onClick={() => this.handleClick()} 
                    className={this.props.className} 
                    hasBackground={this.props.hasBackground}
                >
                    {favorites[sort] && favorites[sort].includes(item.id) ? <StyledFavoriteIconFilled hasBackground={this.props.hasBackground} /> : <FavoriteIcon />}
                </Wrapper>
            </React.Fragment>
            
        )
    }
}

const mapStateToProps = state => ({
    favorites: state.favorites,
})

const actions = {
    setFavoriteHotel,
    setFavoriteAdventure,
    setFavoriteDining,
    setFavoriteEvent,
    setFavoriteConferenceVenue,
    removeFavoriteHotel,
    removeFavoriteAdventure,
    removeFavoriteDining,
    removeFavoriteEvent,
    removeFavoriteConferenceVenue,
}

export default connect(mapStateToProps, actions)(FavoriteButton);


const Wrapper = styled.div`
    cursor: pointer;
    position: relative;
    
    svg {
        height: 19px;
        transition: fill .2s ease;

        &:hover {
            fill: ${props => props.hasBackground ? props.theme.colors.bg : props.theme.colors.button};
        }

        &:active,
        &:visited {
            fill: ${props => props.hasBackground ? props.theme.colors.bg : props.theme.colors.button};
        }

        ${Media.greaterThan('s')`
            height: auto;
        `}
    }
`

const StyledFavoriteIconFilled = styled(FavoriteIconFilled)`
    path {
        fill: ${props => props.hasBackground ? props.theme.colors.bg : props.theme.colors.button};
    }
`